import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import {
  IconCheckListBlack,
  IconHardwareCpu,
  IconHardwareDc,
  IconHardwareRes,
  IconHostingHardware,
} from '@/res/icons'
import { NAMESPACE_HOSTING } from '@/res/namespaces'

import Caption from '../ui/Typo/Caption'
import Description from '../ui/Typo/Description'
import H2 from '../ui/Typo/H2'

const HostingOnFast = () => {
  const { t } = useTranslation(NAMESPACE_HOSTING)
  const items = [
    {
      Icon: IconCheckListBlack,
      text: 'MariaDB - 5.5.68',
    },
    {
      Icon: IconCheckListBlack,
      text: 'Nginx',
    },
    {
      Icon: IconCheckListBlack,
      text: 'Apache',
    },
  ]

  return (
    <div className="container mb-16">
      <H2 uppercase={false} weight="font-semibold" color="text-primary">
        {t('host_on_fast')}
      </H2>
      <div className="laptop:flex justify-between">
        <div className="tablet:flex flex-wrap justify-between laptop:w-[660px]">
          <TextCard
            Icon={IconHostingHardware}
            desc={t('on_fast_ssd')}
            text={t('on_fast_data')}
          />
          <TextCard
            Icon={IconHardwareCpu}
            desc={t('on_fast_processor')}
            text={t('on_fast_vip_tariffs')}
          />
          <TextCard
            Icon={IconHardwareDc}
            desc={t('on_fast_data_center')}
            text={t('on_fast_high_server')}
          />
          <TextCard
            Icon={IconHardwareRes}
            desc={t('on_fast_optimized_resources')}
            text={t('on_fast_optimize_server')}
          />
        </div>

        <div className="w-[324px] mt-8">
          <Description>{t('on_fast_Installed_software')}</Description>
          {items.map(({ Icon, text }) => (
            <TextRow Icon={Icon} text={text} key={text} />
          ))}
        </div>
      </div>
    </div>
  )
}
interface ITextCard {
  Icon: any
  text: string
  desc: string
}

const TextCard: React.FC<ITextCard> = ({ Icon, desc, text }) => {
  return (
    <div className="tablet:px-8 tablet:py-8 px-6 py-4 my-2 border-[1px] rounded-lg tablet:w-[calc(50%-6px)] ">
      <Icon className="mr-4 flex-none fill-[#5f6368]" />
      <Description weight="font-medium" color="text-gray3">
        {desc}
      </Description>
      <Caption color="text-gray3">{text}</Caption>
    </div>
  )
}

interface ITextRow {
  Icon: any
  text: string
}

const TextRow: React.FC<ITextRow> = ({ Icon, text }) => {
  return (
    <div className="flex my-2 items-start ">
      <Icon className="mr-4 flex-none" />
      <Description color="text-gray3" weight="font-medium">
        {text}
      </Description>
    </div>
  )
}

export default HostingOnFast
